module.exports = __webpack_public_path__ + "img/about2.5c4a471e.png";